<template>
  <div class="kui-kbtn" @click="bindClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'kybtn',
  methods: {
    bindClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.kui-kbtn{
  display: inline-block;
  min-width: 100px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border: solid 1px #00c0ef;
  background-color: #00c0ef;
  border-radius: 4px;
  cursor: pointer;
  padding: 0 10px;
}
.kui-kbtn:hover{
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// packages/kbtn/kbtn.vue